import React from "react";
import styled from "@emotion/styled";

const Section = styled.div`
  margin: 100px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  @media (max-width: 1000px) {
    flex-direction: column;
  }
`;

const Rect = styled.div`
  margin: 40px;
  width: 410px;
  min-height: 190px;
  padding: 20px;
  border-radius: 5px;
  flex-direction: column;
  text-align: center;
  background: #2eaf76;

  @media (max-width: 520px) {
    min-height: 150px;
    width: 290px;
  }
`;

const Title = styled.div`
  font-family: ${props => props.theme.fonts.subheading};
  font-size: 24px;
  margin: 20px;
  margin-top: 30px;
`;

const Text = styled.div`
  padding: 5px;
  text-align: center;
`;

export default function VisionMission() {
  return (
    <Section>
      <Rect css={{ background: "#2eaf76" }}>
        <Title>
          <strong>VISION</strong>
        </Title>
        <Text>
          COMPFEST menjadi bentuk pengabdian mahasiswa yang memberi manfaat
          dalam bidang teknologi informasi dengan cara berbagi secara terbuka
          demi Indonesia yang lebih maju.
        </Text>
      </Rect>
      <Rect css={{ background: "#0088d2" }}>
        <Title>
          <strong>MISSION</strong>
        </Title>
        <Text>
          Mewadahi, menggerakkan, dan membangun antusiasme terhadap perkembangan
          teknologi informasi di Indonesia melalui rangkaian Event, Academy,dan
          Competition.
        </Text>
      </Rect>
    </Section>
  );
}
